import { styled, css } from '../../style';

const StyledDiv = styled('div')(
  ({ theme, isActive }) => css`
    background: ${isActive
      ? `linear-gradient(
      90deg,
      #ffdc22 0%,
      #ffb90b 96.77%,
      #ffb600 96.77%
    )`
      : `${theme.colors.activeButtonBG}`};
    border: ${theme.colors.cardBorder};
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    margin: 8px;
    width: 100%;
    cursor: pointer;

    span {
      color: ${isActive ? `#424856` : `${theme.colors.text}`};
      font-weight: bold;
      font-size: 13px;
    }
  `
);

export default StyledDiv;
